<div class="px-3 md:px-10 xl:px-[175px] w-full max-w-[1920px] mx-auto">

<script type="application/ld+json">
    {
 "@context": "https://schema.org",
 "@type": "AboutPage",
 "@id": "https://innovationplaza.it/chi-siamo/#webpage",
 "url": "https://innovationplaza.it/chi-siamo/",
 "name": "Chi Siamo — Innovation Plaza",
 "description": "Innovation Plaza e' una societa' di consulenza di direzione che supporta
imprese, istituzioni e aspiranti imprenditori nell'ecosistema dell'innovazione.",
 "inLanguage": "it-IT",
 "isPartOf": {
 "@id": "https://innovationplaza.it/#website"
 },
 "about": {
 "@id": "https://innovationplaza.it/#organization"
 },
 "breadcrumb": {
 "@type": "BreadcrumbList",
 "itemListElement": [
 { "@type": "ListItem", "position": 1, "name": "Home", "item":
"https://innovationplaza.it/" },
 { "@type": "ListItem", "position": 2, "name": "Chi Siamo", "item":
"https://innovationplaza.it/chi-siamo/" }
 ]
 }
}
</script>

    <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
        style="background:radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

    <div class="mt-[60px] relative text-white text-font40px aspect43:text-center font-normal uppercase">
        <h1 class="text-font36px leading-[40px] font-extrabold mb-2.5 text-center">
            Chi siamo
        </h1>
    </div>

    <div
        class="items-center mb-5 text-white font-normal text-font19px aspect43:text-font26px max-w-[100%] mx-auto flex">
        <div class="text-center text-justify-disabled mx-auto text-font24px font-normal leading-[25px]">
            La nostra realtà, i nostri servizi, il nostro team, i nostri valori e la nostra mission
        </div>
    </div>

    <div class="w-full bg-white rounded-[20px] shadow-lg p-5 xl:p-10">
        <div class="mb-10">
            <img class="w-[350px] h-auto mx-auto cursor-pointer hover:opacity-80 transition-opacity" routerLink="/"
                src="assets/InShot_con_nome.png">
        </div>

        <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
            style="background:radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

        <div class="mt-6 text-font24px font-medium text-[#364349] text-justify">
            <h2 class="!text-font24px">
                Innovation Plaza è una società di consulenza di direzione in grado di supportare i vari attori
                dell’ecosistema dell’innovazione: imprese, istituzioni, aspiranti imprenditori; nei rispettivi processi di analisi,
                strategia, marketing, ideazione e/o gestione di iniziative complesse di sviluppo locale – territoriale e/o
                internazionale – nonché di innovazione e sviluppo imprenditoriale. Ha due sedi una a Milano per il Nord Italia ed una a
                Brindisi per il centro Sud
            </h2>
        </div>
        <br> <br>
        <div class="text-font32px text-[#222222] font-bold leading-[26px]">I nostri servizi</div>
        <br>
        <div class="flex flex-col md:flex-row md:gap-10 mb-6">
            <div class="w-full xl:w-[calc(50%-20px)]">
                <ul class="list-disc pl-5 marker:text-blue-500 space-y-4 custom-marker">
                    <li class="text-font24px text-[#364349]">Project and problem setting</li>
                    <li class="text-font24px text-[#364349]">Technology forecasting</li>
                    <li class="text-font24px text-[#364349]">Studi di fattibilità</li>
                    <li class="text-font24px text-[#364349]">Business planning</li>
                    <li class="text-font24px text-[#364349]">Fund-Raising</li>
                    <li class="text-font24px text-[#364349]">Marketing strategico</li>
                </ul>
            </div>
            <div class="w-full xl:w-[calc(50%-20px)] mt-6 md:mt-0">
                <ul class="list-disc pl-5 marker:text-blue-500 space-y-4 custom-marker">
                    <li class="text-font24px text-[#364349]">Proposal management</li>
                    <li class="text-font24px text-[#364349]">Project management</li>
                    <li class="text-font24px text-[#364349] text-justify">Networking e gestione di partenariati locali,
                        nazionali ed internazionali</li>
                    <li class="text-font24px text-[#364349]">Organizzazione e promozione di eventi (workshop, convegni, incontri di animazione territoriale)</li>
                </ul>
            </div>
        </div>
       
        
        <!-- Sezione Il nostro team -->

        <div class="mt-24 mb-12 border-t border-b pt-20 pb-20">
            <h2 class="text-font32px font-bold text-[#222222] mb-16 text-left">Il nostro team</h2>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div class="group perspective-1000 h-[500px]">
                    <div class="relative w-full h-full transition-transform duration-700 preserve-3d group-hover:rotate-y-180">
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md bg-[#F97316] p-1.5 flex flex-col shadow-xl">
                            <div class="w-full h-[78%] bg-[#F1F5FF] overflow-hidden rounded-md">
                                <img src="assets/Francesco_Carolla.png" alt="Francesco Carolla" class="w-full h-full object-cover">
                            </div>
                            <div class="flex-1 flex flex-col justify-center items-center text-white text-center">
                                <p class="font-bold text-font28px">Francesco Carolla</p>
                                <p class="text-font18px">Managing Partner</p>
                            </div>
                        </div>
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md rotate-y-180 bg-[#F97316] flex items-center justify-center p-8 text-center shadow-xl">
                            <p class="text-white text-font22px font-medium">Managing Partner</p>
                        </div>
                    </div>
                </div>

                <div class="group perspective-1000 h-[500px]">
                    <div class="relative w-full h-full transition-transform duration-700 preserve-3d group-hover:rotate-y-180">
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md bg-[#14B8A6] p-1.5 flex flex-col shadow-xl">
                            <div class="w-full h-[78%] bg-[#F1F5FF] overflow-hidden rounded-md">
                                <img src="assets/Ida_Carolla.png" alt="Ida Carolla" class="w-full h-full object-cover">
                            </div>
                            <div class="flex-1 flex flex-col justify-center items-center text-white text-center">
                                <p class="font-bold text-font28px">Ida Carolla</p>
                                <p class="text-font18px">Partner<br>Esperto per la Pubblica Amministrazione</p>
                            </div>
                        </div>
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md rotate-y-180 bg-[#14B8A6] flex items-center justify-center p-8 text-center shadow-xl">
                            <p class="text-white text-font22px font-medium">Partner<br>Esperto per la Pubblica Amministrazione</p>
                        </div>
                    </div>
                </div>

                <div class="group perspective-1000 h-[500px]">
                    <div class="relative w-full h-full transition-transform duration-700 preserve-3d group-hover:rotate-y-180">
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md bg-[#EF4444] p-1.5 flex flex-col shadow-xl">
                            <div class="w-full h-[78%] bg-[#F1F5FF] overflow-hidden rounded-md">
                                <img src="assets/Domenica_Suma.png" alt="Domenica Suma" class="w-full h-full object-cover">
                            </div>
                            <div class="flex-1 flex flex-col justify-center items-center text-white text-center">
                                <p class="font-bold text-font28px">Domenica Suma</p>
                                <p class="text-font18px">Partner<br>Esperto per le Imprese e le Start up</p>
                            </div>
                        </div>
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md rotate-y-180 bg-[#EF4444] flex items-center justify-center p-8 text-center shadow-xl">
                            <p class="text-white text-font22px font-medium">Partner<br>Esperto per le Imprese e le Start up</p>
                        </div>
                    </div>
                </div>

                <div class="group perspective-1000 h-[500px]">
                    <div class="relative w-full h-full transition-transform duration-700 preserve-3d group-hover:rotate-y-180">
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md bg-[#3B82F6] p-1.5 flex flex-col shadow-xl">
                            <div class="w-full h-[78%] bg-white overflow-hidden rounded-md flex items-center justify-center p-6">
                                <img src="assets/imc-group-logo.png" alt="IMC Group" class="w-full h-auto object-contain">
                            </div>
                            <div class="flex-1 flex flex-col justify-center items-center text-white text-center">
                                <p class="font-bold text-font28px">IMC Group</p>
                                <p class="text-font18px">Partner</p>
                            </div>
                        </div>
                        <div class="absolute inset-0 w-full h-full backface-hidden rounded-md rotate-y-180 bg-[#3B82F6] flex items-center justify-center p-8 text-center shadow-xl">
                            <p class="text-white text-font22px font-medium">
                                <a href="https://www.imc-group.eu/" target="_blank" class="underline hover:text-gray-200 transition-colors duration-200">Partner</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="xl:flex xl:gap-10 mb-[51px] items-center">
            <div class="xl:w-[calc(50%-20px)] px-[29px] py-[54px] rounded-[20px]"
                style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.08)">
                <div class="text-[#719CFF] font-bold text-font45px leading-[47px] text-justify">Trasformiamo le tue
                    idee, connessioni e competenze in opportunità concrete per il futuro</div>
            </div>
            <div class="xl:w-[calc(50%-20px)] mt-5 xl:mt-0">
                <div class="text-font32px text-[#222222] font-bold leading-[34px]">La nostra missione</div>
                <div class="text-font24px text-[#364349] pt-5 text-justify">Facilitiamo l'accesso alla finanza per chi
                    innova, costruendo ponti tra risorse,competenze e territori
                </div>
                <div class="text-font32px text-[#222222] font-bold leading-[34px] mt-10">I nostri valori</div>
                <div class="text-font24px text-[#364349] pt-5 text-justify">Affidabilità, chiarezza, accessibilità,
                    competenza e innovazione guidano ogni nostra azione per garantire un servizio trasparente, efficace e sempre al passo
                    con le esigenze degli utenti
                </div>
            </div>
        </div>
        <div class="xl:flex xl:gap-10 items-center">
            <div class="xl:w-[calc(50%-20px)]">
                <div class="text-font32px text-[#222222] font-bold leading-[34px] text-justify">Lavoriamo per una
                    innovazione accessibile, sostenibile e concreta</div>
                <div class="text-font24px text-[#364349] pt-5 text-justify">Innovation Smart Plaza nasce per migliorare
                    l'accesso a fondi, partner e strumenti per chi vuole trasformare idee in progetti di valore
                    <br><br>
                    L'intelligenza artificiale rappresenta un'evoluzione concreta al servizio di imprese, startup ed  enti
                    pubblici che investono in una crescita solida, responsabile e orientata al futuro
                </div>
            </div>
            <div class="xl:w-[calc(50%-20px)] mt-5 xl:mt-0 p-4 md:px-[29px] md:py-[54px] rounded-[20px]"
                style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.08)">
                <div class="text-[#719CFF] font-bold text-font45px leading-[47px] text-justify">Diamo forma
                    all’innovazione, rendendola accessibile a chi la costruisce ogni giorno</div>
            </div>
        </div>

        <div class="mt-[60px]">
            <div class="px-4 md:px-0">
                <div class="text-font32px font-bold leading-[34px] text-[#222222]">Accesso ai finanziamenti semplificato
                </div>
                <div class="my-5 text-font24px text-[#364349] leading-[26px] text-justify">Grazie all’intelligenza artificiale e al
                    matchmaking intelligente, verifichiamo la tua ammissibilità ai bandi, supportiamo la redazione della documentazione e
                    favoriamo partnership strategiche</div>
            </div>
        </div>
        <div class="md:flex md:gap-5 xl:gap-[40px] md:px-0 md:flex-wrap mb-[60px]">
            <div class="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-30px)] rounded-[20px] p-6 mb-5"
                style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.08)">
                <svg width="80" height="80" class="mx-auto" viewBox="0 0 80 80" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M63.333 26.667C68.8559 26.667 73.333 22.1898 73.333 16.667C73.333 11.1441 68.8559 6.66699 63.333 6.66699C57.8102 6.66699 53.333 11.1441 53.333 16.667C53.333 22.1898 57.8102 26.667 63.333 26.667Z"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M46.7337 7.33366C44.5337 6.90033 42.3003 6.66699 40.0003 6.66699C21.6003 6.66699 6.66699 21.6003 6.66699 40.0003C6.66699 58.4003 21.6003 73.3337 40.0003 73.3337C58.4003 73.3337 73.3337 58.4003 73.3337 40.0003C73.3337 37.7337 73.1003 35.5003 72.667 33.367"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="text-center text-font24px font-bold text-[#222222] leading-[24px] mt-3">Monitoraggio
                    Costante
                </div>
            </div>
            <div class="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-30px)] rounded-[20px] p-6 mb-5"
                style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.08)">
                <svg width="80" height="80" class="mx-auto" viewBox="0 0 80 80" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M60 62.8668H57.4667C54.8 62.8668 52.2666 63.9001 50.4 65.7668L44.7 71.4003C42.1 73.967 37.8667 73.967 35.2667 71.4003L29.5666 65.7668C27.7 63.9001 25.1333 62.8668 22.5 62.8668H20C14.4667 62.8668 10 58.4335 10 52.9669V16.6001C10 11.1334 14.4667 6.7002 20 6.7002H60C65.5333 6.7002 70 11.1334 70 16.6001V52.9669C70 58.4002 65.5333 62.8668 60 62.8668Z"
                        stroke="#719CFF" stroke-width="5" stroke-miterlimit="10" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path
                        d="M23.333 30.533C23.333 27.433 25.8663 24.8994 28.9663 24.8994C32.0663 24.8994 34.5997 27.433 34.5997 30.533C34.5997 36.7996 25.6997 37.4663 23.733 43.4329C23.333 44.6663 24.3663 45.8996 25.6663 45.8996H34.5997"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M53.4659 45.8662V26.833C53.4659 25.9664 52.8992 25.1995 52.0659 24.9662C51.2325 24.7328 50.3326 25.0662 49.8659 25.7995C47.4659 29.6662 44.8659 34.0662 42.5992 37.9329C42.2326 38.5662 42.2326 39.3996 42.5992 40.0329C42.9659 40.6662 43.6659 41.066 44.4326 41.066H56.6659"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="text-center text-font24px font-bold text-[#222222] leading-[24px] mt-3">Supporto Dedicato
                </div>
            </div>
            <div class="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-30px)] rounded-[20px] p-6 mb-5"
                style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.08)">
                <svg width="80" height="80" class="mx-auto" viewBox="0 0 80 80" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M40 50.0003C52.4264 50.0003 62.5 40.2998 62.5 28.3337C62.5 16.3675 52.4264 6.66699 40 6.66699C27.5736 6.66699 17.5 16.3675 17.5 28.3337C17.5 40.2998 27.5736 50.0003 40 50.0003Z"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M25.0665 45.0668L25.0332 69.6668C25.0332 72.6668 27.1332 74.1335 29.7332 72.9001L38.6665 68.6668C39.3999 68.3002 40.6332 68.3002 41.3665 68.6668L50.3332 72.9001C52.8999 74.1001 55.0332 72.6668 55.0332 69.6668V44.4668"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="text-center text-font24px font-bold text-[#222222] leading-[24px] mt-3">Opportunità Mirate
                </div>
            </div>
            <div class="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-30px)] rounded-[20px] p-6 mb-5"
                style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.08)">
                <svg width="85" height="85" viewBox="0 0 85 85" class="mx-auto" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M52.9 44.8196V55.7396C52.9 64.8596 49.26 68.4996 40.14 68.4996H29.26C20.18 68.4996 16.5 64.8596 16.5 55.7396V44.8196C16.5 35.7396 20.14 32.0996 29.26 32.0996H40.18C49.26 32.0996 52.9 35.7396 52.9 44.8196Z"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M68.4996 29.22V40.14C68.4996 49.26 64.8596 52.9 55.7396 52.9H52.8996V44.82C52.8996 35.74 49.2596 32.1 40.1396 32.1H32.0996V29.22C32.0996 20.1 35.7396 16.5 44.8596 16.5H55.7796C64.8596 16.5 68.4996 20.14 68.4996 29.22Z"
                        stroke="#719CFF" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M82.5 54.5C82.5 69.98 69.98 82.5 54.5 82.5L58.7 75.5" stroke="#719CFF" stroke-width="5"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2.5 30.5C2.5 15.02 15.02 2.5 30.5 2.5L26.3 9.5" stroke="#719CFF" stroke-width="5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="text-center text-font24px font-bold text-[#222222] leading-[24px] mt-3">Consulenza Esperta
                </div>
            </div>
        </div>

    </div>
</div>